import { render, staticRenderFns } from "./createCompany.vue?vue&type=template&id=5bc38c4f&scoped=true"
import script from "./createCompany.vue?vue&type=script&lang=js"
export * from "./createCompany.vue?vue&type=script&lang=js"
import style0 from "./createCompany.vue?vue&type=style&index=0&id=5bc38c4f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc38c4f",
  null
  
)

export default component.exports